<template>
  <div
    class="wbs-side-menu d-flex flex-shrink-1"
    :class="{ 'wbs-side-menu--close': toggle }"
  >
    <button
      @click="toggleMenuLateral(toggle)"
      type="button"
      class="btn btn-link wbs-side-menu-toggle--responsivo"
      title="Fechar/Abrir Menu Lateral"
    >
      <i class="mdi mdi-menu-left"></i>
    </button>
    <div class="wbs-side-menu__content shadow">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        :class="{
          'wbs-side-menu__header': item.header,
          'wbs-side-menu__item': !item.header,
          active: menuAtivo == item.id
        }"
      >
        <template v-if="item.header">
          <h5>{{ item.text }}</h5>
          <div class="border-top w-100"></div>
        </template>
        <router-link :to="item.route" class="nav-link" v-if="!item.header">
          <i class="mdi" :class="item.icon"></i>
          {{ item.text }}
        </router-link>
      </div>
      <div class="wbs-side-menu__item-footer">
        <AppRodape />
      </div>
    </div>
  </div>
</template>
<script>
import eventHub from "../../utils/eventHub";

import AppRodape from "./AppRodape.vue";

export default {
  name: "appRodape",
  components: { AppRodape },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    menuAtivo() {
      return this.$route.meta.menuAtivo;
    }
  },
  data() {
    return {
      toggle: false
    };
  },
  created() {
    eventHub.$on("toggle-menu-lateral", this.toggleMenuLateral);
  },
  methods: {
    toggleMenuLateral(val) {
      this.toggle = !val;
      eventHub.$emit("toggle-menu-lateral-responsivo", this.toggle);
    }
  }
};
</script>
<style lang="scss">
.wbs-side-menu {
  width: 220px;
  position: fixed;
  top: 40px;
  bottom: 0;
  z-index: 1;

  @include themify($themes) {
    background-color: themed("sideMenuBackgroundColor");
  }

  @include element("content") {
    transform: none;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
    min-width: 200px;
    transition: all 0.4s ease-in-out;

    @include themify($themes) {
      background-color: themed("sideMenuBackgroundColor");
    }
  }

  @include element("item") {
    font-size: 0.959rem;
    font-weight: bold;

    &.active {
      @include themify($themes) {
        box-shadow: inset 4px 0 0 #2d7052;
      }
      a {
        @include themify($themes) {
          color: themed("sideMenuItemColorActive");
          background-color: themed("sideMenuItemBackgroundColorActive");
        }
      }
    }

    a {
      display: flex;
      align-items: center;

      @include themify($themes) {
        color: themed("sideMenuItemColor");
      }

      &:hover,
      &:focus {
        @include themify($themes) {
          background-color: themed("sideMenuItemBackgroundColorActive");
        }
      }

      & i {
        margin-right: 8px;
        font-size: 1rem;
      }
    }
  }

  @include element("item-footer") {
    margin-top: auto;
    padding: 0.5rem 1rem;
  }

  @include element("header") {
    margin-right: 1rem;
    margin-left: 1rem;
    margin-top: 1rem;
    padding-bottom: 0.5rem;
    & h5 {
      font-size: 0.82rem;
      font-weight: 600;
      text-transform: UPPERCASE;
    }
    @include themify($themes) {
      color: themed("sideMenuHeaderColor");
    }
  }

  @include modifier("close") {
    .wbs-side-menu__content {
      display: none !important;
    }
    .wbs-side-menu-page {
      padding-left: 0;
    }
  }

  &.wbs-side-menu--close {
    width: 0;
  }

  @include media-breakpoint-down(sm) {
    & {
      top: 84px;
    }
  }
}

.wbs-side-menu-toggle {
  font-size: 1.8rem;
  padding: 6px 5px;
  color: #19171c;
  opacity: 0.25;

  &:hover {
    color: #19171c;
    opacity: 0.5;
  }

  @include modifier("responsivo") {
    position: absolute;
    right: 0;
    font-size: 1.8rem;
    padding: 3px 5px;
    color: #19171c;
    opacity: 0.25;

    &:hover {
      color: #19171c;
      opacity: 0.5;
    }

    @include media-breakpoint-up(md) {
      display: none;
    }
  }
}

/**
* Div que tem o conteudo
*/
.wbs-side-menu-page {
  padding-left: 220px;
  transition: all 0.4s ease-in-out;

  @include media-breakpoint-down(sm) {
    padding-left: 0;
  }
}
</style>
